/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["utils/jsonpath_parser", "underscore"], function(JSONPathParser, _) {

return {

  evalParsedPath: function(elts, obj) {
      if (obj == undefined) {
          throw new Error("Unable to evaluate path " + elts + " for undefined");
      }
      // console.log(JSON.stringify(elts));
      var p = obj;
      for (var i = 0; i < elts.length;++i) {
          if (p == undefined || p == null) {
              throw new Error("Unable to get property " + elts[i] + " for " + p);
          }
          // console.log("path " + elts[i]);
          p = p[elts[i]];
          // console.log("obj " + JSON.stringify(p));
      }
      return p;
  },


  evalPath: function(path, obj) {
      var elts = JSONPathParser.parse(path);
      return this.evalParsedPath(elts, obj);
  },


  parsePath: function(path, options) {
    if (_.isArray(path)) {
      return path;
    }
    if (_.isNumber(path)) {
      return [path];
    }
    if (!_.isString(path)) {
      return null;
    }
    try {
      return JSONPathParser.parse(path, options);
    } catch(e) {
      // console.log("Failed to parse path", path, e);
      return null;
    }
  },

  stringifyPath: function(path) {
    path = this.parsePath(path);
    var str = "";
    _.each(path, function(elt) {
      if (_.isString(elt) && elt.match(/^[A-Za-z_$][:A-Za-z0-9_$]+$/)) {
        if (str.length) str += ".";
        str += elt;
      }
      else if (!_.isString(elt) && !_.isNumber(elt))
        throw new Error("JSONPath.stringify - expected string/number, got: " + elt);
      else
        str += "[" + JSON.stringify(elt) + "]";
    });
    return str;
  },


  _applyPropToArray: function(elts, prop) {
    if (elts == null) return elts;
    var idx = parseInt(prop);
    if (!_.isArray(elts) || !_.isNaN(idx)) { return elts[prop]; }

    var idCount = 0, idResults = [];
    var result =_.reduce(elts, function(memo,elt) {
      if (_.isObject(elt)) {
        if (elt[prop] != null) {
          if (memo == null) memo = [];
          memo.push(elt[prop]);
        }
        else if (_.isString(elt.id)) {
          idCount++;
          if (elt.id == prop) {
            idResults.push(elt);
          }
        }
      }
      return memo;
    }, undefined);

    if (result == null && idCount == elts.length && idResults.length > 0) {
      if (idResults.length == 1)
        result = idResults[0];
      else
        result = idResults;
    }
    return result;
  },

  get: function(obj, elts, maxdepth) {
    // if (_.isArray(obj)) {
    //   console.log("GET: ",  JSON.stringify(obj, null, 1), JSON.stringify(elts));
    // }
    if (obj == null) {
      return obj;
    }

    if (!_.isArray(elts))
      elts = this.parsePath(elts);

    if (maxdepth === undefined) {
      maxdepth = elts.length;
    } else {
      maxdepth = Math.min(elts.length, maxdepth);
    }

    if (maxdepth < 0) {
      maxdepth = elts.length + maxdepth;
    }
    if (maxdepth <= 0) return obj;

    var p = obj;
    for (var i = 0; i < maxdepth;++i) {
      if (p == null) { // == also includes undefined
        return p;
      }
      // if p is String or Number we compare the last element against it.
      if ((_.isString(p) || _.isNumber(p)) && i == maxdepth - 1) {
        if (p == elts[i]) {
          return true;
        }
        return null;
      }

      // console.log("parent: " + JSON.stringify(parent));
      if (_.isObject(p) && _.isNumber(elts[i])) {
        var keys = _.keys(p);
        var key = keys[elts[i]];
        p = p[key];
      }
      else if (_.isArray(p) && !_.isNumber(elts[i])) {
        // console.log(JSON.stringify(p) + " " + elts[i]);
        p = this._applyPropToArray(p, elts[i]);
      } else {
        p = p[elts[i]];
      }
      // console.log("obj " + JSON.stringify(p));
    }
    return p;
  },

  unset: function(obj, elts) {
    if (obj == null) {
      return false;
    }

    if (!_.isArray(elts))
      elts = this.parsePath(elts);

    if (!elts || elts.length == 0) {
      return false;
    }
    var parent = this.get(obj, elts, -1);
    // console.log(parent);
    var lastelt = elts[elts.length - 1];
    // console.log(JSON.stringify(lastelt));
    if (_.isArray(parent) && _.isString(lastelt)) {
      var parsed = parseInt(lastelt);
      if (!isNaN(parsed)) {
        lastelt = parsed;
      }
    }
    if (!parent) {
      return true;
    } else if (_.isArray(parent) && !_.isNumber(lastelt)) {
      var foundOnce = false;
      _.each(parent, function (p) {
        if (!p) return;

        if (p[lastelt] != undefined) {
          delete p[lastelt];
          foundOnce = true;
        }
      });
      return foundOnce;
    } else {
      // console.log("subscript");
      if (_.isArray(parent)) {
        parent.splice(lastelt, 1);
      }
      else if (parent[lastelt] != undefined) {
        delete parent[lastelt];
        return true;
      }
    }
    return false;
  },


  clonePath: function(root, elts) {
    // var root = obj;
    var entries = [];
    if (!_.isArray(elts))
      elts = this.parsePath(elts);

    // if (!elts || elts.length == 0) {
    //  return false;
    // }

    var cloned = [];
    cloned.push(_.clone(root));
    var obj = root;
    for (var i = 0; i < elts.length; i++) {
      var pathelt = elts[i];
      obj = this.get(obj, [pathelt]);
      if (!_.isArray(obj) && !_.isObject(obj)) break;
      cloned.push(_.clone(obj));
    }

    for (var i = cloned.length - 1;
         i > 0;
         i--) {
      var offset = i - 1;
      this.set(cloned[offset], elts[offset], cloned[i]);
    }

    return cloned[0];
  },

  //
  // sets value on obj applied path
  // <code>
  //    set({a: { b: { c: 10} } }, ["a","b"], 3)
  //      --> {a: { b: 3 } }
  // <code>
  //
  // @param obj
  // @param elts
  // @param value
  // @returns
  //
  set: function(obj, elts, value) {
    if (obj == null) {
      return false;
    }

    if (!_.isArray(elts))
      elts = this.parsePath(elts);
    // console.log(obj);
    // console.log(elts);
    if (!elts || elts.length == 0) {
      return false;
    }

    var gp = null;
    var p = obj;
    for (var i = 0; i < elts.length - 1;++i) {
      var pathelt = elts[i];
      //console.log("pathelt ", pathelt);
      // console.log("parent: " + JSON.stringify(parent));
      var np;

      if (_.isArray(p) && !_.isNumber(pathelt)) {
        np = _.map(p, function (p) {
          if (!p) return p;
          return p[pathelt];
        });
      } else {
        np = p[pathelt];
      }

      //console.log("next p", np);

      if (np == null || !(_.isArray(np) ||  _.isObject(np))) { // == also includes undefined

        if (_.isNumber(elts[i+1])) {
          np = [];
        }
        else {
          np = {};
        }
        p[pathelt] = np;
      }

      //console.log("parent " + JSON.stringify(p));
      p = p[pathelt];

      //console.log("obj " + JSON.stringify(p));
    }

    var lastelt = elts[elts.length - 1];
    // console.log("lastelt: " + lastelt);

    if (_.isArray(p) && !_.isNumber(lastelt)) {
      var parsedLastelt = parseInt(lastelt);
      if (_.isNaN(parsedLastelt)) {
        _.each(p, function (p) {
          if (!p) return;
          return p[lastelt] = value;
        });
      }
      else {
        p[parsedLastelt] = value;
      }
    }
    else {
      p[lastelt] = value;
    }
    /// console.log("parent: " + JSON.stringify(parent));

    return true;
  },

  //
  // sets value on obj applied path
  // <code>
  //    add({a: { b: [] } }, "a.b", 3)
  //      --> {a: { b: [ 3 ]} }
  // <code>
  //
  // @param obj
  // @param elts
  // @param value
  // @returns
  //
  add: function(obj, elts, value) {
    if (obj == null) {
      return false;
    }

    if (!_.isArray(elts))
      elts = this.parsePath(elts);
    // console.log(obj);
    // console.log(elts);
    if (!elts || elts.length == 0) {
      return false;
    }

    var gp = null;
    var p = obj;
    // create the elements, like set
    // "
    for (var i = 0; i < elts.length;++i) {
      var pathelt = elts[i];
      //console.log("pathelt ", pathelt);
      // console.log("parent: " + JSON.stringify(parent));
      var np;

      if (_.isArray(p) && !_.isNumber(pathelt)) {
        np = _.map(p, function (p) {
          if (!p) return p;

          return p[pathelt];
        });
      } else {
        np = p[pathelt];
      }

      //console.log("next p", np);

      if (np == null || !(_.isArray(np) ||  _.isObject(np))) { // == also includes undefined

        if (i == elts.length -1  || _.isNumber(elts[i+1])) {
          np = [];
        }
        else {
          np = {};
        }
        // console.log("create subelement: ", np, "elt: ", pathelt);
        p[pathelt] = np;
      }

      //console.log("parent " + JSON.stringify(p));
      p = p[pathelt];

      //console.log("obj " + JSON.stringify(p));
    }

    if (!_.isArray(p)) {
      // TODO: test the value for being an object, then
      //       we could merge the properties here.
      // console.log("Add cannot be applied to non arrays.")
      return false;
    }

    var s =  JSON.stringify(value);
    for (var k = p.length - 1; k >= 0; --k) {
      if (JSON.stringify(p[k]) == s) return false;
    }

    p.push(value);
    /// console.log("parent: " + JSON.stringify(parent));

    return true;
  },

  startsWith: function(elts, prefixElts) {
    if (!_.isArray(elts) || !_.isArray(prefixElts)) return false;
    if (prefixElts.length > elts) {
      return false;
    }

    for (var i = prefixElts.length -1 ; i >= 0; i--) {
      if (elts[i] !== prefixElts[i])
        return false;
    }
    return true;
  },

  
  getMatchingPaths: function(obj, pred, path)
  {
    path = path || [];
    var result = [];
    var that = this;
    
    if (pred(obj)) {
      result.push(path);
    }
    
    if (!_.isArray(obj) && !_.isObject(obj)) 
      return result;

    function handleKey(key) {
      _.each(that.getMatchingPaths(obj[key], pred, path.concat([key])), 
             function(path) {
               result.push(path);
             });        
    }
    
    var keys = _.isArray(obj) ? _.range(0, obj.length) : _.keys(obj);
    _.each(keys, handleKey);
    
    return result;
  }
  

}});
